import React, { useEffect, useRef } from 'react';
import './Login.css';
import { endSessionUrl } from '../auth/oidcConfig';

// Der Notausgang.
//
// Der Abmeldeknopf in der Navigationsleiste setzt eine funktionierende Sitzung
// voraus: er ruft oidc.signoutRedirect(), und das braucht einen gueltigen
// Eintrag im oidc-Speicher. Genau der fehlt in den Faellen, in denen man diese
// Seite braucht - abgelaufener oder halb geschriebener Zustand, ein state, den
// Keycloak nicht mehr kennt, ein bereits eingeloester Code. Dann hilft weder
// der Knopf noch Neuladen, weil bei jedem Anlauf derselbe kaputte Zustand
// wieder gelesen wird.
//
// Diese Seite kommt ohne all das aus: erst den Speicher raeumen, dann die
// Abmeldeadresse selbst bauen und den Browser dorthin schicken. Sie ist damit
// auch der einzige Weg, die Keycloak-Sitzung von hier aus sicher zu beenden.

// Alles, was oidc-client-ts und diese App ueber eine Anmeldung ablegen.
// oidc-client-ts praefixt jeden eigenen Schluessel mit "oidc." - die Liste
// aufzuzaehlen waere falsch, weil pro angefangenem Anmeldevorgang ein
// weiterer state-Eintrag dazukommt.
function purgeStoredSession() {
  for (const store of [window.localStorage, window.sessionStorage]) {
    for (const key of Object.keys(store)) {
      if (key.startsWith('oidc.')) store.removeItem(key);
    }
    store.removeItem('username');
    store.removeItem('sessionExpiredMessage');
  }
}

// Das Token wird direkt aus dem Speicher gelesen statt aus dem Kontext: Wenn
// react-oidc-context den Zustand nicht laden konnte, steht dort nichts mehr,
// im Speicher aber sehr wohl. Mit dem Hint bleibt dem Nutzer Keycloaks
// Bestaetigungsseite erspart; ohne ihn kostet es einen Klick mehr, und mehr
// nicht.
function storedIdToken() {
  try {
    const key = Object.keys(window.localStorage).find((k) => k.startsWith('oidc.user:'));
    return key ? (JSON.parse(window.localStorage.getItem(key))?.id_token || '') : '';
  } catch {
    return '';
  }
}

const Logout = () => {
  // React fuehrt Effekte im Entwicklungsmodus doppelt aus. Ohne die Sperre
  // liefe der zweite Durchlauf ohne id_token_hint, weil der erste den Speicher
  // schon geraeumt hat - und der Nutzer saehe grundlos die Bestaetigungsseite.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const idToken = storedIdToken();
    purgeStoredSession();
    // Merker fuer die Loginseite, damit sie stehen bleibt statt sofort wieder
    // zu Keycloak weiterzuleiten.
    window.localStorage.setItem('abgemeldet', '1');
    window.location.assign(endSessionUrl({ idToken }));
  }, []);

  return (
    <div className="login-container">
      <div className="login-box">
        <h1> Open KI IoT Hub </h1>
        <h2>Abmelden</h2>
        <p>Sie werden abgemeldet…</p>
      </div>
    </div>
  );
};

export default Logout;
